import { Select } from 'antd';
import { type VFC, useMemo } from 'react';
import type { SelectProps } from 'antd/lib/select';
import type { SerializedManufacturer } from '@enmon/commons/lib/tools';
import { useManufacturers } from 'api/hooks/manufacturers/useManufacturers';
import type { Commodity } from '@enmon/commons/lib/shared';
import { filterOption, filterSort } from '../utils';
import { mapListToIdSelectOptions } from '../../../utils/mapListToIdSelectOptions';

type ManufacturerId = SerializedManufacturer['id'] | null;

export interface ManufacturersSelectProps extends SelectProps<ManufacturerId> {
  commodity?: Commodity;
  onChange?: (value: ManufacturerId) => void;
}

export const ManufacturersSelect: VFC<ManufacturersSelectProps> = props => {
  const { commodity, onChange, ...propsToPass } = props;

  const { data: manufacturers, isFetching: isLoadingManufacturers } = useManufacturers({
    commodity,
    limit: -1,
    start: 0,
    fields: ['id', 'name'],
  });

  const manufacturersOptions =
    useMemo(() => mapListToIdSelectOptions(manufacturers?.data ?? []), [manufacturers]) ?? [];

  return (
    <Select
      allowClear
      showSearch
      filterOption={filterOption}
      filterSort={filterSort}
      loading={isLoadingManufacturers}
      optionFilterProp="label"
      options={manufacturersOptions}
      placeholder="Select Manufacturer"
      popupMatchSelectWidth={false}
      onChange={onChange}
      {...propsToPass}
    />
  );
};
